import palette from "../mainPalette";

export default {
	underline: {
		"&:hover:not($disabled):before": {
			borderBottomColor: palette.site.primary
		}
	}
};
